import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material'
import LeadContactoSelector from '../../components/form/LeadContactoSelector/LeadContactoSelector'
import TelefonoInput from '../../components/form/TelefonoInput/TelefonoInput'
import { getPhoneValidationState, phoneToString } from '../../utils/phone'
import css from './ModalEditarDatosTelefono.module.css'

const ModalEditarDatosTelefono = ({
  open,
  telefonosContacto,
  onSubmit,
  onClose
}) => {
  const [telefonos, setTelefonos] = useState([])

  useEffect(() => {
    if (open) {
      const hasTelefonos = telefonosContacto && telefonosContacto.length > 0
      if (hasTelefonos) setTelefonos(telefonosContacto)
      else
        setTelefonos([{ nombre: '', telefono: '', prefijoInternacional: '' }])
    }
  }, [open, telefonosContacto])

  const handleSubmit = () => onSubmit(telefonos)

  const handleAddTelefono = () => {
    setTelefonos([
      ...telefonos,
      { nombre: '', telefono: '', prefijoInternacional: '' }
    ])
  }

  const handleRemoveTelefono = index => {
    const newTelefonos = telefonos.filter((_, i) => i !== index)
    setTelefonos(newTelefonos)
  }

  const handleUpdateTelefono = (index, field, value) => {
    const newTelefonos = [...telefonos]
    newTelefonos[index] = {
      ...newTelefonos[index],
      [field]: value
    }
    setTelefonos(newTelefonos)
  }

  const handleUpdateTelefonoWithDetails = (index, event, details) => {
    const newTelefonos = [...telefonos]
    newTelefonos[index] = { ...newTelefonos[index], ...details }
    setTelefonos(newTelefonos)
  }

  const isSubmitDisabled = telefonos.some(
    t => getPhoneValidationState(t) === 'error'
  )

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Editar teléfonos</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.content}>
          <div className={css.container}>
            {telefonos.map((telefono, index) => (
              <div key={index} className={css.row}>
                <div className={css.inputsContainer}>
                  <LeadContactoSelector
                    name={`nombre-${index}`}
                    className={css.contactoInput}
                    value={telefono.nombre}
                    onChange={(_event, value) =>
                      handleUpdateTelefono(index, 'nombre', value)
                    }
                  />
                  <TelefonoInput
                    name={`telefono-${index}`}
                    className={css.telefonoInput}
                    label='Teléfono'
                    value={phoneToString(telefono)}
                    onChange={(event, details) =>
                      handleUpdateTelefonoWithDetails(index, event, details)
                    }
                  />
                </div>
                <div className={css.actions}>
                  <IconButton
                    className={css.removeButton}
                    onClick={() => handleRemoveTelefono(index)}
                    size='small'
                    color='error'
                    disabled={index === 0}
                  >
                    <span className='material-icons'>delete</span>
                  </IconButton>
                  <span
                    className={`material-icons ${css.icon}`}
                    data-status={getPhoneValidationState(telefono)}
                  >
                    {getPhoneValidationState(telefono) === 'success' &&
                      'check_circle'}
                    {getPhoneValidationState(telefono) === 'warning' &&
                      'warning'}
                    {getPhoneValidationState(telefono) === 'error' && 'error'}
                  </span>
                </div>
              </div>
            ))}
            <Button
              className={css.addButton}
              variant='outlined'
              color='primary'
              onClick={handleAddTelefono}
              startIcon={<span className='material-icons'>add</span>}
            >
              Añadir teléfono
            </Button>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          color='primary'
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarDatosTelefono
